import { render, staticRenderFns } from "./UpdateComplexityDialog.vue?vue&type=template&id=2784b049&"
import script from "./UpdateComplexityDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateComplexityDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports